import { Shield, AlertTriangle, Star, TrendingUp } from "lucide-react";

export default function AnalysisPanel({ analysis }) {
  if (!analysis) return null;

  return (
    <div className="analysis-panel" data-testid="analysis-panel">
      {/* Summary */}
      <div className="analysis-section">
        <h3 className="analysis-title">
          <TrendingUp size={16} /> Chart Summary
        </h3>
        <div className="analysis-items">
          {analysis.summary.map((item, i) => (
            <p key={i} className="analysis-text">{item}</p>
          ))}
        </div>
      </div>

      {/* Best Doors */}
      {analysis.best_doors.length > 0 && (
        <div className="analysis-section">
          <h3 className="analysis-title">
            <Shield size={16} /> Best Directions
          </h3>
          <div className="analysis-items">
            {analysis.best_doors.map((door, i) => (
              <div key={i} className="door-analysis-card">
                <div className="door-analysis-header">
                  <span className="door-analysis-dir">{door.direction}</span>
                  <span className="door-analysis-name">{door.door}</span>
                  <span className="door-analysis-score">
                    {"*".repeat(Math.max(0, door.score))}
                  </span>
                </div>
                {door.reasons.length > 0 && (
                  <ul className="door-analysis-reasons">
                    {door.reasons.map((r, j) => (
                      <li key={j}>{r}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Warnings */}
      {analysis.warnings.length > 0 && (
        <div className="analysis-section">
          <h3 className="analysis-title analysis-warning-title">
            <AlertTriangle size={16} /> Warnings
          </h3>
          <div className="analysis-items">
            {analysis.warnings.map((w, i) => (
              <p key={i} className="analysis-warning">{w.message}</p>
            ))}
          </div>
        </div>
      )}

      {/* Star Strength */}
      <div className="analysis-section">
        <h3 className="analysis-title">
          <Star size={16} /> Star Assessment
        </h3>
        <div className="star-grid">
          {analysis.star_strength.map((s, i) => (
            <div key={i} className={`star-card star-${s.quality.toLowerCase()}`}>
              <span className="star-card-name">{s.star}</span>
              <span className="star-card-en">{s.star_en}</span>
              <span className={`star-card-quality quality-${s.quality.toLowerCase()}`}>
                {s.quality}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
